import React from 'react';
const noop = () => {};
const CheckboxGroup = ({ children, values = [], onChange = noop, disabled }) => {
  return (
    React.Children.map(children, ((child) => React.cloneElement(child, {
      checked: (values || []).some(value => value === child.props.value),
      disabled: disabled,
      onChange: (e) => {
        if ((values || []).some(value => value === child.props.value)) {
          onChange(values.reduce((next, value) => {
            if (value === child.props.value) {
              return next;
            }
            next.push(value);
            return next;
          }, []).sort())
        } else {
          onChange((values || []).concat(child.props.value).sort())
        }
      },
    })))
  );
};

export default CheckboxGroup;
